var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-dialog-wrapper"},[_c('div',{staticClass:"loading-dialog-mask"}),_c('div',{staticClass:"loading-dialog-content"},[_c('div',{staticClass:"loading-animation"},[_c('div',{staticClass:"loading-spinner"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }